import { DEFAULT_SUBFLOW } from '@conversed/shared/src/central/constants/flow';
import { useCallback, useMemo } from 'react';

import { useMainSelector } from '../../useMainSelector';
import { useFlow } from '../flow/useFlow';

export const useBlocks = () => {
  const {
    designer: { blocks, selectedBlock },
  } = useMainSelector();

  const { selectedSubFlow } = useFlow();

  const filteredBlocks = useMemo(() => {
    return (
      blocks?.filter((block) => {
        if (selectedSubFlow === DEFAULT_SUBFLOW && !block.subFlow) {
          return true;
        }

        return block.subFlow === selectedSubFlow;
      }) ?? []
    );
  }, [blocks, selectedSubFlow]);

  const gates = useMemo(
    () => blocks?.filter((block) => block.type === 'gate') || [],
    [blocks],
  );

  const getBlocksBySubflow = useCallback(
    (subFlow: string) => {
      return (
        blocks?.filter((block) => {
          if (subFlow === DEFAULT_SUBFLOW && !block.subFlow) {
            return true;
          }

          return block.subFlow === subFlow;
        }) ?? []
      );
    },
    [blocks],
  );

  const hasButtonBlocksWithoutDestination = useMemo((): boolean => {
    return (blocks || [])?.some(
      (block) => block.type === 'button' && !block?.destination?.[0]?.trim(),
    );
  }, [blocks]);

  return {
    selectedBlock,
    gates,
    blocks: filteredBlocks,
    getBlocksBySubflow,
    hasButtonBlocksWithoutDestination,
  };
};
